import { commonUtils } from './components/common_utils';

const paymentReceipt = {
    validateFormData() {
        if (commonUtils.isEmpty($('#paymentReceiptSite').val())) {
            alert(Translations.own_ad.payment_receipt.error.select_site);
            return false;
        }

        if (commonUtils.isEmpty($('#paymentReceiptMonth').val())) {
            alert(Translations.own_ad.payment_receipt.error.select_month);
            return false;
        }

        if (commonUtils.isEmpty($('#paymentYear').val())) {
            alert(Translations.own_ad.payment_receipt.error.select_year);
            return false;
        }

        return true;
    },
    sendMail() {
        $.post(Routing.generate('payment_receipt_send_mail'), $('#bankReceipt').serialize(), function (response) {
            window.$.colorbox.close();
            if (response.status) {
                commonUtils.showNotification(Translations.own_ad.payment_receipt.mail_sent);
            } else if (response.status === false && response.message) {
                commonUtils.showNotification(response.message);
            }
        });
    },
    createPdf() {
        let { height } = screen;
        height -= 80;
        window.$.colorbox.close();
        commonUtils.openNewWindow(
            `${Routing.generate('payment_receipt_create_pdf')}?${$('#bankReceipt').serialize()}`,
            730,
            height,
            'bankreceipt'
        );
    },
};

$(function () {
    let $body = $('body');

    // Send payment receipt mail
    $body.on('click', '.sendPaymentReceiptMail', function () {
        if (paymentReceipt.validateFormData()) {
            paymentReceipt.sendMail();
        }
    });

    // Create payment receipt pdf
    $body.on('click', '.generatePaymentReceiptPdf', function () {
        if (paymentReceipt.validateFormData()) {
            paymentReceipt.createPdf();
        }
    });

    // Payment receipt Modal
    $body.on('click', '.paymentReceiptModal', function () {
        window.$.colorbox({
            href: Routing.generate('payment_receipt_modal'),
        });
    });
});
